<template>
  <div>
    <!-- <b-modal
    id="bv-add-address"
    size="lg"
    :hide-footer="true"
    :hide-header="true"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    centered
    header-class="my-class"
    body-class="p-0"
  > -->
    <b-card class="card-custom-class">
      <div class="closemodel">
        <button
          @click="
            $bvModal.hide('bv-add-address');
            reset();
          "
          type="button"
        >
          <span>
            <img src="img/address/close.png" alt />
          </span>
        </button>
      </div>
      <b-icon
        class="mr-1"
        icon="geo-alt-fill"
        scale="1.8"
        variant="success"
      ></b-icon>
      <span class="change-location-text">{{
        $t("viewAddress.addAddress")
      }}</span>
    </b-card>
    <b-card>
      <v-form>
        <v-row>
          <v-col cols="12">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('viewAddress.fullName')"
            >
              <v-text-field
                v-model="fullName"
                :label="$t('viewAddress.fullName')"
              ></v-text-field>
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <GmapAutocomplete
              id="LocationAddress12"
              @place_changed="placechange1"
              ref="address12"
              class="form-control tx-13"
              :placeholder="$t('enterLocation')"
              :options="{
                fields: ['geometry', 'formatted_address', 'address_components'],
              }"
            ></GmapAutocomplete>
          </v-col>
        </v-row>
        <v-container>
          <ValidationObserver v-slot="{ invalid }" ref="observer">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Street"
                >
                  <v-text-field
                    v-model="area"
                    :label="$t('viewAddress.streetAddress')"
                  ></v-text-field>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <!-- <ValidationProvider
									rules="required"
									v-slot="{ errors }"
									name="Building, Company, Apartment"
								> -->
                <v-text-field
                  v-model="building"
                  :label="$t('viewAddress.building')"
                ></v-text-field>
                <!-- <span class="validate-error">{{
										errors[0]
									}}</span>
								</ValidationProvider> -->
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <!-- <ValidationProvider
									rules="required"
									v-slot="{ errors }"
									name="House Number"
								> -->
                <v-text-field
                  v-model="houseNumber"
                  :label="$t('viewAddress.unitNum')"
                ></v-text-field>
                <!-- <span class="validate-error">{{
										errors[0]
									}}</span>
								</ValidationProvider> -->
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <ValidationProvider
                  rules="required|zipcode"
                  v-slot="{ errors }"
                  :name="$t('viewAddress.zipCode')"
                >
                  <v-text-field
                    v-model="zip"
                    :label="$t('viewAddress.zipCode')"
                  ></v-text-field>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <ValidationProvider
                  rules="required|max:20|min:2"
                  v-slot="{ errors }"
                  :name="$t('viewAddress.city')"
                >
                  <v-text-field
                    v-model="city"
                    :label="$t('viewAddress.city')"
                  ></v-text-field>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <ValidationProvider
                  rules="required|max:20|min:2"
                  v-slot="{ errors }"
                  :name="$t('viewAddress.state')"
                >
                  <v-text-field
                    v-model="state"
                    :label="$t('viewAddress.state')"
                  ></v-text-field>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <ValidationProvider
                  rules="required|max:20|min:2"
                  v-slot="{ errors }"
                  :name="$t('viewAddress.country')"
                >
                  <v-text-field
                    v-model="country"
                    :label="$t('viewAddress.country')"
                  ></v-text-field>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" md="6"></v-col>
              <v-col cols="12" sm="6" md="6">
                <ValidationProvider
                  rules="required|usPhone"
                  v-slot="{ errors }"
                  :name="$t('viewAddress.phoneNum')"
                >
                  <v-text-field
                    v-model="phoneNumber"
                    :label="$t('viewAddress.phoneNum')"
                  ></v-text-field>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <ValidationProvider
                  rules="email"
                  v-slot="{ errors }"
                  :name="$t('viewAddress.email')"
                >
                  <v-text-field
                    v-model="email"
                    :label="$t('viewAddress.email')"
                    :placeholder="$t('viewAddress.email')"
                  ></v-text-field>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <b-form-select
                  v-model="addressType"
                  :placeholder="$t('viewAddress.selectAddressType')"
                  :name="$t('viewAddress.addressType')"
                  id="Address Type"
                  class="form-control"
                  size="1"
                >
                  <option disabled value="Select an Address Type">
                    {{ $t("viewAddress.selectAddressType") }}
                  </option>
                  <option value="Home">{{ $t("viewAddress.home") }}</option>
                  <option value="Office">{{ $t("viewAddress.office") }}</option>
                  <option value="Other">{{ $t("viewAddress.other") }}</option>
                </b-form-select>
              </v-col>
              <v-col
                style="margin-top: 4px; font-size: 1.125rem"
                cols="12"
                sm="6"
                md="6"
              >
                <b-row>
                  <b-col md="5">
                    <b-card-text class="price-details">{{
                      $t("viewAddress.defaultAddress")
                    }}</b-card-text>
                  </b-col>
                  <b-col md="7">
                    <b-form-radio-group
                      v-model="defaultAddressKey"
                      id="radio-group-2"
                      name="radio-sub-component"
                    >
                      <b-form-radio size="lg" :value="true">Yes</b-form-radio>
                      <b-form-radio size="lg" :value="false">No</b-form-radio>
                    </b-form-radio-group>
                  </b-col>
                  <!-- <b-col md="3"> </b-col> -->
                </b-row>
              </v-col>

              <b-col>
                <div class="addAddressBtn">
                  <template v-if="!isLoading">
                    <button
                      @click="
                        $bvModal.hide('bv-add-address');
                        reset();
                      "
                      type="button"
                      class="btn btn-outline-primary btn-lg"
                    >
                      <span class="button-text"></span>
                      {{ $t("viewAddress.cancel") }}
                    </button>
                    <p style="display: none">{{ invalid }}</p>
                    <button
                      @click="onSubmitAddress"
                      type="button"
                      class="btn btn-primary btn-lg"
                    >
                      <span class="button-text"></span>
                      {{ $t("viewAddress.save") }}
                    </button>
                  </template>
                  <template v-if="isLoading">
                    <b-spinner
                      v-for="i in 3"
                      :key="i"
                      class="mr-1"
                      small
                      label="Small Spinner"
                      type="grow"
                    ></b-spinner>
                  </template>
                </div>
              </b-col>
            </v-row>
          </ValidationObserver>
        </v-container>
      </v-form>
    </b-card>
    <!-- </b-modal> -->
  </div>
</template>
<script>
// import locationExtract from "../../../shared/mixins/locationExtract";
import locationExtract from "../../../shared/mixins/locationExtract";
import { mapState } from "vuex";
import {
  extend,
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full.esm";

extend("usPhone", {
  validate(value) {
    const cleaned = value.trim();
    return /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}$/.test(cleaned);
  },
  message: "The {_field_} field must be a valid US phone number",
});

extend("zipcode", {
  validate: (value) => /^\d{5}(-\d{4})?$/.test(value),
  message: "Enter a valid ZIP code (e.g., 12345 or 12345-6789)",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [locationExtract],

  data() {
    return {
      fullName: "",
      houseNumber: "",
      building: "",
      area: "",
      zip: "",
      city: "",
      state: "",
      country: "",
      phoneNumber: "",
      email: "",
      addressType: "Home",
      defaultAddressKey: true,
      isLoading: false,
    };
  },
  computed: {
    ...mapState({ userInfo: (state) => state.auth.userInfo }),
  },
  methods: {
    reset() {
      Object.assign(this.$data, this.$options.data());
    },
    async placechange1(e) {
      let extractData = await this.extractLocation(e);
      if (Object.keys(extractData).length != 0) {
        if (extractData.data.Country) {
          this.country = extractData.data.Country;
        }
        if (extractData.data.State) {
          this.state = extractData.data.State;
        }
        if (extractData.data.zip) {
          this.zip = extractData.data.zip;
        }
        if (extractData.data.City) {
          this.city = extractData.data.City;
        }
        if (extractData.address) {
          this.area = extractData.address.split(",")[0];
        }
      }
    },

    async onSubmitAddress() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isLoading = true;
      let payload = {
        fullName: this.fullName,
        houseNumber: this.houseNumber,
        street2: this.building || this.area,
        street1: this.area,
        zip: this.zip,
        city: this.city,
        state: this.state,
        country: this.country,
        phoneNumber: this.phoneNumber,
        email: this.email,
        category: this.addressType,
        isDefault: this.defaultAddressKey,
      };
      // localStorage.setItem(`${process.env.VUE_APP_TENANT}:address_popup`, JSON.stringify(payload));
      await this.$store
        .dispatch("address/adAddress", payload)
        .then(() => {
          this.$bvModal.hide("bv-add-address");
          this.$swal({
            title: this.$t("wishlistProduct.successTitle"),
            text: this.$t("swal.addressAdded"),
            type: "success",
          });
          this.reset();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$bvModal.hide("bv-add-address");
          this.$swal({
            title: this.$t("swal.error"),
            text: this.$t("swal.addressNotAdded"),
            type: "error",
          });
          this.reset();
        });
      await this.$store.dispatch("address/fetchDeliveryAddress");
      await this.$store.dispatch("checkout/checkoutFinal");
    },
  },
  props: {},
  mounted() {
    this.fullName = `${this.userInfo?.name?.first || ""} ${this.userInfo?.name?.last || ""}`;
    this.email = this.userInfo?.authentication?.email || "";
  },
};
</script>
<style scoped>
.addAddressBtn {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}
.addAddressBtn .btn {
  width: 150px;
  margin-left: 15px;
}
.card-custom-class {
  border: none;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-bottom-color: rgba(0, 0, 0, 0.125);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-radius: 0.25rem;
}
/*  */
.list-group-modal {
  margin-top: 7px;
  max-height: 540px;
  margin-left: 10px;
  margin-right: 4px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.change-location-text {
  font-style: normal;
  font-weight: 520;
  font-size: 1.625rem;
  line-height: 24px;
  margin-left: 15px;
  margin-top: 8px;
  color: #2e2e2e;
}
.coupon-input {
  border: 0;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
  outline: 0;
  width: 75%;
}
.text-danger {
  color: var(--primarycolor) !important;
  font-size: 0.875rem;
  vertical-align: 5px;
}
.add-new-address-text {
  font-style: normal;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 20px;
  color: var(--primarycolor);
  cursor: pointer;
  position: absolute;
  right: 75px;
}
.address-name {
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 20px;
  text-transform: uppercase;
  color: #000000;
}
.body-class-modal {
  margin-top: -7px;
}

.address-details-text {
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 20px;
  text-transform: capitalize;
  color: #2e2e2e;
  margin-left: 37px;
  margin-top: 4px;
}

.my-class {
  background: black;
  color: white;
}
.closemodel {
  position: absolute;
  top: 15px;
  right: 12px;
}

.default-address-class {
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 19px;
  color: #717171;
  margin-left: 10px;
}
@media (max-width: 768px) {
  .addAddressBtn .btn {
    width: 100%;
    margin-left: 0;
    margin-bottom: 15px;
  }
  .addAddressBtn {
    display: block;
  }
}
::v-deep .v-input__slot label {
  left: 0px !important;
}
</style>
